"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ProcessSetter = exports.HasNoMatchInStorage = exports.HandleClose = void 0;
var AlertMethods = _interopRequireWildcard(require("./Alert"));
var SiteConfigMethods = _interopRequireWildcard(require("./../../utils/hooks/useSiteConfigContext"));
var _Error = _interopRequireDefault(require("@mui/icons-material/Error"));
var _ImportedContentFragment = _interopRequireDefault(require("./../ContentFragments/ImportedContentFragment"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _generateId = require("./../../utils/generateId");
var _array = require("./../../utils/type-checks/array");
var _function = require("./../../utils/type-checks/function");
var _isStorageSupported = require("./../../utils/misc-checks/isStorageSupported");
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
var _string = require("./../../utils/type-checks/string");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const merge = require("deepmerge"),
  HandleClose = (e, id, setter) => {
    let closedAlerts,
      result = null;
    if (e && (0, _function.isFunction)(e.preventDefault) && window && window.sessionStorage && (0, _function.isFunction)(window.sessionStorage.setItem)) {
      e.preventDefault();
      closedAlerts = window.sessionStorage.getItem("closed_alerts");
      if ((0, _string.isString)(closedAlerts)) {
        closedAlerts = closedAlerts.split(",");
        if (!closedAlerts.includes(id)) {
          closedAlerts.push(id);
        }
        result = closedAlerts;
      } else {
        result = [id];
      }
      result = result.join(",");
      window.sessionStorage.setItem("closed_alerts", result);
    }
    if ((0, _function.isFunction)(setter)) {
      setter(false);
    } else {
      result = null;
    }
    return result;
  },
  HasNoMatchInStorage = id => {
    let result = true,
      closedAlerts;
    if (window && window.sessionStorage && (0, _function.isFunction)(window.sessionStorage.getItem) && (0, _string.isStringOfLength)(window.sessionStorage.getItem("closed_alerts"))) {
      closedAlerts = window.sessionStorage.getItem("closed_alerts").split(",");
      if ((0, _array.isArrayOfLength)(closedAlerts) && closedAlerts.includes(id)) {
        result = false;
      }
    }
    return result;
  },
  ProcessSetter = (value, setter) => {
    let result = false;
    if ((0, _function.isFunction)(setter)) {
      setter(value);
      result = true;
    }
    return result;
  };

/**
 * Sitewide Alert Message, use in header or as child of the main content container
 *
 * @visibleName Alert
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
exports.ProcessSetter = ProcessSetter;
exports.HasNoMatchInStorage = HasNoMatchInStorage;
exports.HandleClose = HandleClose;
const Alert = props => {
  const {
      allowClose = true,
      children,
      className,
      containerClassName,
      // if passed in, used to indicate which maintenance alert to be used.
      contextId = (0, _generateId.generateId)(),
      customContainerStyles = {},
      customIcon = /*#__PURE__*/_react.default.createElement(_Error.default, {
        sx: {
          color: "#CC0000",
          height: "3.6rem",
          width: "3.6rem"
        }
      }),
      customMuiAlertStyles = {},
      customTheme = {},
      // if alert needs to be turned off entirely.
      defaultIsOpen = undefined,
      fragmentId,
      id,
      initialTheme = {},
      containerTestId,
      muiAlertTestId
    } = props,
    theme = merge.all([initialTheme, (0, _styles.useTheme)(), customTheme]),
    closeIsSupported = _isStorageSupported.isSessionStorageSupported,
    {
      maintenance
    } = SiteConfigMethods.useSiteConfigContext(),
    // setting isOpen to false, useLayoutEffect below to open/close modal
    [isOpen, setIsOpen] = (0, _react.useState)(false),
    compiledClassName = (0, _classnames.default)({
      "alert": true,
      [`${className}`]: className
    }),
    compiledContainerClassName = (0, _classnames.default)({
      "alert__container": true,
      [`${containerClassName}`]: containerClassName
    }),
    handleClose = e => AlertMethods.HandleClose(e, id, setIsOpen);
  (0, _react.useLayoutEffect)(() => {
    let isOpenWindow = false,
      // set to true, if the alert id is not found in the session storage
      hasNoMatch = AlertMethods.HasNoMatchInStorage(id),
      // filtering maintenance array from configuration.json to see if alert is maintenance alert
      settings = maintenance.filter(item => item.id === contextId);

    // if maintenance alert
    if ((0, _array.isArrayOfLength)(settings)) {
      // set to true if defaultIsOpen isn't false AND no sessionStorage match AND message set to show based on current time
      isOpenWindow = defaultIsOpen !== false && hasNoMatch && settings[0].isInMessage;
    } else {
      // if not a maintenance alert, set to true if defaultIsOpen is true and no sessionStorage match
      isOpenWindow = defaultIsOpen === true && hasNoMatch;
    }

    // if isOpen doesn't equal isOpenWindow
    if (isOpen !== isOpenWindow) {
      // set value of isOpen to value of isOpenWindow
      AlertMethods.ProcessSetter(isOpenWindow, setIsOpen);
    }
  }, [contextId, defaultIsOpen, maintenance, id, isOpen, setIsOpen]);
  return /*#__PURE__*/_react.default.createElement(_material.Container, {
    className: compiledContainerClassName,
    "data-testid": containerTestId,
    sx: merge.all([theme.mixins.container.outer, {
      backgroundColor: "rgba(215, 25, 32, 0.1)",
      display: isOpen && id ? "block" : "none",
      "h1,h2,h3,h4,h5,h6": {
        fontFamily: theme.fontFamilies.bold,
        fontSize: "inherit",
        margin: "0 0 0.4rem",
        padding: "0"
      },
      "strong": {
        fontFamily: theme.fontFamilies.bold,
        fontWeight: "normal"
      },
      "* + p": {
        margin: "0.4rem 0 0"
      },
      ".MuiAlert-message": {
        fontFamily: theme.fontFamilies.default
      }
    }, customContainerStyles]),
    id: id
  }, isOpen && /*#__PURE__*/_react.default.createElement(_material.Alert, {
    className: compiledClassName,
    "data-testid": muiAlertTestId,
    icon: customIcon,
    onClose: allowClose && closeIsSupported ? handleClose : undefined,
    severity: "error",
    slotProps: {
      closeIcon: {
        sx: {
          height: "3.95rem",
          width: "3.95rem"
        }
      }
    },
    sx: merge.all([theme.mixins.container.inner, {
      backgroundColor: "transparent",
      borderRadius: "unset",
      color: "#000000",
      fontFamily: theme.fontFamilies.semiBold,
      fontSize: "1.6rem",
      padding: "1.9rem 0 2.4rem"
    }, customMuiAlertStyles])
  }, children, fragmentId && !children && /*#__PURE__*/_react.default.createElement(_ImportedContentFragment.default, {
    id: fragmentId
  })));
};

// Define propTypes;
Alert.propTypes = {
  /** Boolean that activates close alert button (Default Value: true) */
  allowClose: _propTypes.default.bool,
  /** Contents inserted into alert */
  children: _propTypes.default.any,
  /** Parent container custom class(es) */
  containerClassName: _propTypes.default.string,
  /** Context ID that corresponds to an ID in site alert configuration (Default Value: generateId() value) */
  contextId: _propTypes.default.string,
  /** Container Styles Override Object (Default Value: {}) */
  customContainerStyles: _propTypes.default.object,
  /** Custom Icon Node (Default Value: ErrorIcon MUI Component) */
  customIcon: _propTypes.default.node,
  /** MUI Alert Styles Override Object (Default Value: {}) */
  customMuiAlertStyles: _propTypes.default.object,
  /** Theme object for MUI Theme injection (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** Renders the alert as visible by default */
  defaultIsOpen: _propTypes.default.bool,
  /** Content fragment id, inserts only if there is no children property */
  fragmentId: _propTypes.default.string,
  /** ID of the alert, for tracking when to close via cookie value */
  id: _propTypes.default.string.isRequired,
  /** @ignore */
  containerTestId: _propTypes.default.string
};

// Export component as default;
var _default = exports.default = Alert;